import { api } from './BaseService'

export const getSuppliers = async () => {
    return await api.get(`/suppliers`)
}

export const getSupplierById = async (id) => {
    return await api.get(`/suppliers/${id}`)
}

export const createSupplier = async (data) => {
    return await api.post(`/suppliers`, data)
}
export const updateSupplier = async (data) => {
    return await api.put(`/suppliers/${data?.id}`, data)
}
export const deleteSupplier = async (id) => {
    return await api.delete(`/suppliers/${id}`)
}
